import { setPricelists, setPriceListsSelection } from "../slice/pricingSlice";
import { apiSlice } from "./apiSlice";

export const pricingApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPricelists: builder.query({
      query: params => ({
        url: "/api/pricing/v1/pricelist/",
        params,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setPricelists(result.data))).catch(error => {});
      },
      providesTags: ["Pricelist"],
    }),
    getPriceListsSelection: builder.query({
      query: () => "/api/pricing/v1/pricelist/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setPriceListsSelection(result.data)))
          .catch(error => {});
      },
      providesTags: ["Pricelist"],
    }),
    getPricelist: builder.query({
      query: id => `/api/pricing/v1/pricelist/${id}/`,
      providesTags: (result, error, id) => [{ type: "Pricelist", id }],
    }),
    createPricelist: builder.mutation({
      query: data => ({
        url: "/api/pricing/v1/pricelist/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Pricelist"],
    }),
    updatePricelist: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/pricing/v1/pricelist/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Pricelist", id }, "Pricelist"],
    }),
    deletePricelist: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/pricelist/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Pricelist"],
    }),
    submitPricelist: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/pricelist/${id}/submit/`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Pricelist", id }, "Pricelist"],
    }),
    unpublishPricelist: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/pricelist/${id}/unpublish/`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Pricelist", id }, "Pricelist"],
    }),
    bulkSubmitPricelists: builder.mutation({
      query: ids => ({
        url: "/api/pricing/v1/pricelist/bulk_submit/",
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: ["Pricelist"],
    }),
    bulkUnpublishPricelists: builder.mutation({
      query: ids => ({
        url: "/api/pricing/v1/pricelist/bulk_unpublish/",
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: ["Pricelist"],
    }),

    // Pricelist Items (standalone CRUD — ERP UI uses nested items_data on pricelist save)
    getPricelistItems: builder.query({
      query: params => ({
        url: "/api/pricing/v1/pricelist_item/",
        params,
      }),
      providesTags: ["PricelistItem", "Pricelist"],
    }),

    // Pricelist Formulas
    getPricelistFormulasSelection: builder.query({
      query: params => ({
        url: "/api/pricing/v1/pricelist_formula/selection/",
        params,
      }),
      providesTags: ["PricelistFormula", "Pricelist"],
    }),
    createPricelistFormula: builder.mutation({
      query: data => ({
        url: "/api/pricing/v1/pricelist_formula/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PricelistFormula"],
    }),
    getPricelistFormula: builder.query({
      query: id => `/api/pricing/v1/pricelist_formula/${id}/`,
      providesTags: (result, error, id) => ["Pricelist", { type: "PricelistFormula", id }],
    }),
    updatePricelistFormula: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/pricing/v1/pricelist_formula/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "PricelistFormula", id },
        "PricelistFormula",
      ],
    }),
  }),
});

export const {
  useGetPricelistsQuery,
  useGetPriceListsSelectionQuery,
  useLazyGetPriceListsSelectionQuery,
  useGetPricelistQuery,
  useCreatePricelistMutation,
  useUpdatePricelistMutation,
  useDeletePricelistMutation,
  useSubmitPricelistMutation,
  useUnpublishPricelistMutation,
  useBulkSubmitPricelistsMutation,
  useBulkUnpublishPricelistsMutation,
  useGetPricelistItemsQuery,
  useLazyGetPricelistItemsQuery,
  useGetPricelistFormulasSelectionQuery,
  useCreatePricelistFormulaMutation,
  useGetPricelistFormulaQuery,
  useUpdatePricelistFormulaMutation,
} = pricingApiSlice;
